class PageAnimations {
	constructor() {
		// this.pageBackgroundAnimation();
		this.loadAnimations();
		// this.lazyLoad();
		// this.titleLoadAnimation();
	}

	pageBackgroundAnimation() {
		const parentElement = document.querySelector('main');
		const colors = [
			'rgba(205, 38, 83, .05)',
			'rgba(32, 219, 41, .05)',
			'rgba(2, 125, 221, .05)',
			'rgba(0, 0, 0, .02)'
		];
		const timeCreate = 500;
		const timeDuration = 20000;

		function createSquare() {
			const square = document.createElement('div');
			parentElement.style.setProperty('--bg-animation-time', `${timeDuration}ms`);
			let size = Math.random() * 50;
			let top = Math.random() * (parentElement.clientHeight - 100);
			let left = Math.random() * (parentElement.clientWidth - 100);
			// let left = Math.random() * innerWidth;
			// if (left > innerWidth - 100) {
			// 	left = innerWidth - 100;
			// }
			const color = colors[Math.floor(Math.random() * colors.length)];
			square.classList.add('background-square');
			square.style.height = `${20 + size}px`;
			square.style.width = `${20 + size}px`;
			square.style.top = `${top}px`;
			square.style.left = `${left}px`;
			square.style.backgroundColor = color;
			parentElement.appendChild(square);

			setTimeout(() => {
				square.remove();
			}, timeDuration)
		}

		setInterval(createSquare, timeCreate);

		window.addEventListener('resize', () => {
			let height = parentElement.clientHeight;
			let width = parentElement.clientWidth;
			let squares = document.querySelectorAll('.background-square');
			squares.forEach((square) => {
				if (square.offsetLeft > width - 100 || square.offsetTop > height - 100) {
					square.remove();
				}
			})
		})
	}

	loadAnimations() {
		window.addEventListener('DOMContentLoaded', animation);

		function animation() {
			const loadElements = document.querySelectorAll('.load');
			const options = {
				root: null,
				threshold: 0.25,
				rootMargin: '0px'
			};
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) {
						return;
					} else {
						entry.target.classList.add('loaded');
						observer.unobserve(entry.target);
					}
				})
			}, options);

			loadElements.forEach(element => {
				observer.observe(element);
			})
		}
	}

	lazyLoad() {
		let lazyLoadOptions = {
			root: null, //element, jehož plochu má náš prvek překrývat
			rootMargin: '0px', //vnější okraj kolem root, kdy se hlídač aktivuje
			threshold: 0.25 //práh protnutí v % (jaká část prvku musí jít vidět, aby se hlídač aktivoval)
		}

		let lazyLoadCallback = (entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting && entry.target.className === 'load') {
					let imageUrl = entry.target.getAttribute('data-img')
					if (imageUrl) {
						entry.target.src = imageUrl
						observer.unobserve(entry.target)
					}
				}
			})
		}

		let lazyLoadObserver = new IntersectionObserver(lazyLoadCallback, lazyLoadOptions)
		let lazyLoadElement = document.querySelector('.load')
		lazyLoadObserver.observe(lazyLoadElement)
	}

	lazyLoadImages() {
		const lazyLoadImages = document.querySelectorAll('img')

		let lazyLoadImagesOptions = {}

		let lazyLoadImagesCallback = (entries, observer) => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) return
				const image = entry.target
				// const newUrl = image.getAttribute('data-src')
				// image.src = newUrl
				// image.src = image.src.replace('&w=10&', '&w=800&')
				observer.unobserve(image)
			})
		}

		let lazyLoadImagesObserver = new IntersectionObserver(lazyLoadImagesCallback, lazyLoadImagesOptions)

		lazyLoadImages.forEach(image => {
			lazyLoadImagesObserver.observe(image)
		})
	}

	titleLoadAnimation() {
		window.addEventListener('DOMContentLoaded', titleAnimation);

		function titleAnimation() {
			const textElements = document.querySelectorAll('.title-load');
			const options = {
				root: null,
				threshold: 0,
				rootMargin: '0px 0px -300px 0px'
				// rootMargin: '0px 0px -200px 0px'
			};
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) {
						return;
					} else {
						entry.target.classList.add('visible');
						observer.unobserve(entry.target);
					}
				})
			}, options);

			textElements.forEach(element => {
				observer.observe(element);
			})
		}
	}
}

new PageAnimations();
